'use strict';

import execute_on from "../../../libs/execute-on";
import {attachNumber} from "../../../components/form/number";

execute_on('panel.points-packages.history', function ($page) {
    $page
        .on('click', '.adjustBalance', showAdjustBalancePopup)
    ;
});

function showAdjustBalancePopup(event) {
    event.preventDefault();

    const url = $(event.currentTarget).parent().prop('href');
    const $adjustBalanceModal = $('#adjustBalanceModal');

    $adjustBalanceModal
        .modal('show')
        .find('.modal-content')
        .html('<div class="m-5 text-center">' +
            '<div class="spinner-border mb-3" role="status"></div>' +
            '<strong class="d-block">Loading data, please wait...</strong>' +
            '</div>')
        .load(url, function (responseText, textStatus) {
            if ('error' === textStatus) {
                return $(this).html(responseText);
            }

            attachNumber($(event.delegateTarget));
        });
}
